module.exports = __webpack_public_path__ + "files_1.9c72652c5f5577219fed111d0ef55717.svg";